var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "task-cell",
      on: {
        mouseenter: function ($event) {
          _vm.showOverlay = true
        },
        mouseleave: function ($event) {
          _vm.showOverlay = false
        },
      },
    },
    [
      _vm.task
        ? _c(
            "div",
            {
              staticClass: "task-info",
              on: {
                click: function ($event) {
                  return _vm.viewTask(_vm.task)
                },
              },
            },
            [
              _c("FieldIcon", {
                staticClass: "task-icon",
                attrs: { type: "task", size: 16 },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "task-title" }, [
                _vm._v(_vm._s(_vm.task.title)),
              ]),
            ],
            1
          )
        : _c("a", { on: { click: _vm.showTaskPicker } }, [
            _vm._v("+ Task Ekle"),
          ]),
      _vm._v(" "),
      _vm.showOverlay && _vm.task && !_vm.readonly
        ? _c(
            "div",
            { staticClass: "overlay-actions" },
            [
              _c("a-button", {
                staticStyle: { "margin-right": "4px" },
                attrs: { icon: "edit", size: "small" },
                on: { click: _vm.editTask },
              }),
              _vm._v(" "),
              _c("a-button", {
                attrs: { icon: "delete", type: "danger", size: "small" },
                on: { click: _vm.removeTask },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Task Seç",
                okText: "Kaydet",
                xlarge: "",
                className: "task-picker-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("TaskListView", {
                attrs: { "picker-mode": "" },
                on: { selected: _vm.onTaskSelected },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }